<mp-autocomplete
  appearance="fill"
  autocompleteIcon="person"
  placeholder="Ansprechpartner auswählen"
  [options]="filteredOptions()"
  [optionTemplate]="optionTemplate"
  [clearable]="true"
  [inline]="true"
  [hint]="hint()"
  [(selectedValue)]="selectedValue"
  (selectedValueChange)="emitValueChange($event); onTouched()"
  (searchTermChange)="onSearchTermChange($event)"
  #userAutocomplete
>
  <ng-template #optionTemplate mpTypedTemplate [contextType]="userAutocomplete.optionTemplateContextType" let-option>
    <span class="font-bold">{{ option.value.name }} ({{ option.value.email }})</span>
  </ng-template>
</mp-autocomplete>
